<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container pa-6 fluid>
      <div class="d-flex mb-4" id="farm-select">
        <h2>{{ $t("animals") }}</h2>
        <v-select
          v-if="!tab.includes(`group`)"
          style="max-width: 20%; margin-left: 20px"
          outlined
          dense
          item-text="address"
          item-value="id"
          :items="filteredFarmLocationList"
          attach
          v-model="searchFarmId"
          placeholder="Select Farm"
          @input="searchByFarmId"
          disabled
        >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-list-item-content>
                <v-text-field
                  outlined
                  dense
                  v-model="searchFarmAddress"
                  @input="searchFarmLocation"
                  placeholder="Search by Farm/Owner name"
                >
                </v-text-field>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
        <v-spacer></v-spacer>
        <template>
          <div>
            <v-tooltip top color="black" max-width="350">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  class="mr-2"
                  dark
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  @click="showCreateGroupDialog = true"
                >
                  {{ $t("Create a Group") }}
                </v-btn>
              </template>
              <span>
                {{ $t("createGroupI") }}
              </span>
            </v-tooltip>

            <v-btn
              color="primary"
              depressed
              dark
              @click="checkIfFreeMemberAndMoreThanHunderdAnimals()"
            >
              {{ $t("farm.registerAnAnimal") }}
            </v-btn>
          </div>
        </template>
      </div>
      <v-card elevation="0">
        <v-card-text>
          <div class="">
            <template>
              <v-tabs class="tabs-pill" v-model="tab">
                <v-tab
                  @click="fetchAnimals('')"
                  exact
                  :to="{ name: 'Animals', query: { type: 'all' } }"
                  class="text-capitalize"
                  >{{ $t("animal.all") }} ({{ animalsCount.all }})</v-tab
                >
                <v-tab
                  @click="fetchAnimals(getCategoryId('bull'))"
                  exact
                  :to="{ name: 'Animals', query: { type: 'bulls' } }"
                  class="text-capitalize"
                  >{{ $t("animal.bulls") }} ({{ animalsCount.bulls }})</v-tab
                >
                <v-tab
                  @click="fetchAnimals(getCategoryId('lactating cow'))"
                  exact
                  :to="{ name: 'Animals', query: { type: 'lactatingcows' } }"
                  class="text-capitalize"
                  >{{ $t("animal.lactatingCows") }} ({{
                    animalsCount.lactatingCows
                  }})</v-tab
                >
                <v-tab
                  @click="fetchAnimals(getCategoryId('dry cow'))"
                  exact
                  :to="{ name: 'Animals', query: { type: 'drycows' } }"
                  class="text-capitalize"
                  >{{ $t("animal.dryCows") }} ({{
                    animalsCount.dryCows
                  }})</v-tab
                >
                <v-tab
                  @click="fetchAnimals(getCategoryId('heifer'))"
                  exact
                  :to="{ name: 'Animals', query: { type: 'heifer' } }"
                  class="text-capitalize"
                  >{{ $t("animal.heifer") }} ({{ animalsCount.heifer }})</v-tab
                >
                <v-tab
                  @click="fetchAnimals(getCategoryId('calves'))"
                  exact
                  :to="{ name: 'Animals', query: { type: 'calf' } }"
                  class="text-capitalize"
                  >{{ $t("animal.calves") }} ({{ animalsCount.calf }})</v-tab
                >
                <v-tab
                  @click="isTypeGroup ? getGroups : fetchAnimals('group')"
                  exact
                  :to="{ name: 'Animals', query: { type: 'groups' } }"
                  class="text-capitalize"
                  >{{ $t("groups") }} ({{ totalGroups }})
                </v-tab>
                <v-tab
                  @click="fetchAnimals('archived')"
                  exact
                  :to="{ name: 'Animals', query: { type: 'archived' } }"
                  class="text-capitalize"
                  >{{ $t("Archived") }} ({{ animalsCount.archived }})
                </v-tab>
              </v-tabs>
            </template>
          </div>

          <div ref="document">
            <v-data-table
              v-if="getGroups || getAnimals"
              @click:row="rowClicked"
              :footer-props="{
                'items-per-page-options': itemsPerPageOptions,
                'show-first-last-page': true,
                'show-current-page': true,
              }"
              :headers="isTypeGroup ? groupsTableHeaders : tableHeaders"
              :loading="$apollo.loading"
              :loading-text="$t('animal.loadingAnimals')"
              :items="isTypeGroup ? getGroups : getAnimals"
              :items-per-page="itemsPerPage"
              :options.sync="tableOptions"
              :show-select="!isTypeGroup"
              class="elevation-1"
              v-model="selected"
              :header-props="{
                'sort-icon': 'mdi-unfold-more-horizontal',
              }"
              :sort-by="sortBy"
              :sort-desc="sortDesc"
            >
              <template v-slot:top>
                <div class="d-flex mt-5">
                  <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    :placeholder="$t('search')"
                    dense
                    v-model="search"
                    @input="resetSearchOnEmpty"
                    class="shrink"
                  >
                  </v-text-field>
                  <v-spacer></v-spacer>
                  <div class="py-3">
                    {{
                      (tableOptions.page - 1) * tableOptions.itemsPerPage + 1
                    }}
                    -
                    {{
                      tableOptions.page * tableOptions.itemsPerPage -
                      (tableOptions.itemsPerPage - count)
                    }}
                    of {{ totalCount }}
                  </div>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="tableOptions.page == 1"
                    @click="pageChange(false)"
                  >
                    <v-icon dark> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="
                      (tableOptions.page - 1) * tableOptions.itemsPerPage +
                        count >=
                      totalCount
                    "
                    @click="pageChange(true)"
                  >
                    <v-icon dark> mdi-chevron-right </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="pdfDownloadConfirmation"
                  >
                    <v-img src="/icons/download.svg"></v-img>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="printPDF"
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    left
                    :min-width="417"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> mdi-cog-outline </v-icon>
                      </v-btn>
                    </template>

                    <v-card width="417">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $t("customization")
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div class="pl-3 pt-2 font-weight-normal">
                          {{ $t("recordsPerPage") }}
                        </div>
                        <v-list-item>
                          <v-list-item-content>
                            <v-slider
                              v-model="itemsPerPageSlider"
                              :tick-labels="itemsPerPageOptions"
                              :max="3"
                              step="1"
                              ticks="always"
                              tick-size="4"
                            ></v-slider>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-n3"></v-divider>
                      </v-list>
                      <v-card-text>
                        <v-container fluid>
                          <v-row>
                            <v-col
                              class="mt-n9"
                              cols="6"
                              v-for="header in headers"
                              :key="header.value"
                            >
                              <v-checkbox
                                v-if="!isTypeGroup && header.text !== ''"
                                v-model="selectedHeaders"
                                :label="header.text"
                                color="primary"
                                :value="header.text"
                                hide-details
                                :disabled="
                                  header.text == 'ID' || header.text == 'Tag #'
                                "
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-layout justify-center>
                        <v-card-actions class="mb-5">
                          <v-spacer></v-spacer>

                          <v-btn
                            outlined
                            color="primary"
                            @click="resetDefaut"
                            width="190"
                          >
                            {{ $t("restoreDefault") }}
                          </v-btn>
                          <v-btn
                            color="primary"
                            @click="resetTableStructure"
                            width="190"
                          >
                            {{ $t("apply") }}
                          </v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-card>
                  </v-menu>
                </div>

                <div class="d-flex mt-2" v-if="selected && selected.length">
                  <v-btn
                    @click="bulkAnimalAction('moveToGroup')"
                    depressed
                    class="font-weight-bold my-2 mr-2"
                    color="primary"
                    v-if="type !== 'archived'"
                  >
                    {{ $t("moveToGroup") }}
                  </v-btn>
                  <v-btn
                    @click="bulkAnimalAction('unarchived')"
                    depressed
                    class="font-weight-bold my-2 mr-2"
                    color="primary"
                    v-if="type == 'archived'"
                  >
                    {{ $t("unarchiveAnimals") }}
                  </v-btn>
                  <v-btn
                    @click="bulkAnimalAction('archiveAnimal')"
                    depressed
                    class="font-weight-bold my-2 mr-2"
                    color="primary"
                    v-if="type !== 'archived'"
                  >
                    {{ $t("archiveAnimals") }}
                  </v-btn>
                </div>
              </template>
              <template v-slot:progress>
                <v-progress-linear
                  color="primary"
                  :height="8"
                  indeterminate
                ></v-progress-linear>
              </template>
              <template
                v-slot:no-data
                v-if="isTypeGroup ? groups.length : animals.length < 1"
              >
                <!-- {{ $t("animal.noANIMALAVAILABLE") }} -->
                <!-- <v-progress-linear
                indeterminate
                color="green"
              ></v-progress-linear> -->
              </template>
              <template v-slot:item.id="{ item }">
                <span class="d-flex align-center">
                  <img
                    :src="
                      item?.animalPicture
                        ? item?.animalPicture
                        : '/img/animalDetailBg.png'
                    "
                    style="
                      height: 30px;
                      width: 30px;
                      border-radius: 50%;
                      margin-right: 10px;
                    "
                  />
                  {{ item.id }}
                </span>
              </template>
              <template v-if="isTypeGroup" v-slot:item.groupStatus="{ item }">
                <div>
                  {{ item.groupStatus }}
                </div>
              </template>
              <template v-else v-slot:item.status="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      :color="
                        animalRemovalMenu.find(r => item.status === r.type)
                          ? animalRemovalMenu.find(r => item.status === r.type)
                              .color
                          : 'primary'
                      "
                      rounded
                      small
                      depressed
                    >
                      {{ item.status }}
                      <v-icon style="font-size: 14px; color: #787878"
                        >mdi-chevron-down</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-card class="action-list">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content
                          style="cursor: default"
                          @click.prevent="changeStatus(item, 'Sold')"
                        >
                          <v-list-item-title>{{ "Sold" }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <v-list>
                      <v-list-item>
                        <v-list-item-content
                          style="cursor: default"
                          @click.prevent="changeStatus(item, 'Slaughtered')"
                        >
                          <v-list-item-title>{{
                            "Slaughtered"
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click.prevent="changeStatus(item, 'Dead')">
                        <v-list-item-content style="cursor: default">
                          <v-list-item-title>{{ "Dead" }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </template>

              <template v-slot:item.animalCounts="{ item }">
                <span v-if="item.animalCounts">{{ item.animalCounts }}</span
                ><span v-else
                  ><a
                    @click.stop.prevent="assignAnimaltoGroup(item)"
                    href="#"
                    >{{ $t("animal.addAnimal") }}</a
                  ></span
                >
              </template>

              <template v-slot:item.dob="{ item }">
                {{ item.dob ? item.dob : "" | formatDateYmd }}
              </template>

              <template v-slot:item.name="{ item }">
                <div v-if="item?.name !== 'Ungrouped Animals'">
                  <span v-if="item?.name">{{ item.name }}</span>
                </div>

                <a v-else @click.stop.prevent="rowClicked(item)" href="">{{
                  item.name
                }}</a>
              </template>

              <template v-slot:item.tagNumber="{ item }">
                {{ item.tagNumber ? item.tagNumber : "" }}
              </template>

              <template v-slot:item.regDate="{ item }">
                {{ item.regDate ? item.regDate : "" | formatDateYmd }}
              </template>

              <template v-slot:item.assignZone="{ item }">
                <div v-if="item?.name !== 'Ungrouped Animals'">
                  <span v-if="item?.gefenceZoneName">{{
                    item.gefenceZoneName
                  }}</span>
                  <a
                    v-else
                    @click.stop.prevent="assignZonetoGoal(item)"
                    href=""
                    >{{ $t("animal.dashboardS.assignZone") }}</a
                  >
                </div>
                <span v-else>-</span>
              </template>

              <template v-slot:item.actions="{ item }">
                <div v-if="isTypeGroup">
                  <v-btn icon><v-icon color="blue">mdi-pencil</v-icon></v-btn>
                  <v-btn
                    v-if="item?.name !== 'Ungrouped Animals'"
                    icon
                    @click.stop.prevent="deleteGroup(item)"
                    ><v-icon color="red">mdi-trash-can</v-icon></v-btn
                  >
                </div>
                <v-menu
                  v-else
                  :close-on-content-click="false"
                  offset-y
                  :transition="false"
                >
                  <template #activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      v-show="selected.length <= 0"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-card class="action-list">
                    <v-list v-if="type == 'archived'">
                      <v-list-item>
                        <v-list-item-content
                          style="cursor: default"
                          @click="unArchiveAnimal(item)"
                        >
                          <v-list-item-title>{{
                            "Unarchive"
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <v-list v-if="type != 'archived'">
                      <v-list-item>
                        <v-list-item-content
                          style="cursor: default"
                          @click="moveToGroup(item)"
                        >
                          <v-list-item-title>{{
                            $t("moveToGroup")
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click.prevent="assignZonetoAnimal(item)">
                        <v-list-item-content style="cursor: default">
                          <v-list-item-title>{{
                            $t("animal.dashboardS.assignZone")
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-show="selected.length <= 1"
                        @click="gotoPerformance(item.id)"
                      >
                        <v-list-item-content style="cursor: default">
                          <v-list-item-title>{{
                            "Check Performance"
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-show="selected.length <= 1"
                        @click="clickEditAnimal(item.id)"
                      >
                        <v-list-item-content style="cursor: default">
                          <v-list-item-title>{{
                            "Edit Animal"
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        @click="archiveAnimal(item)"
                        v-if="item.archive !== true"
                      >
                        <v-list-item-content style="cursor: default">
                          <v-list-item-title>{{ "Archive" }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </template>
              <template v-slot:item.breedId="{ item }">
                <span>{{
                  item && item.userBreed || item.breedId
                }}</span>
              </template>
            </v-data-table>
          </div>
          <upload-animals
            :dialogI="showUploadAnimal"
            @closeUploadAnimal="closeUploadAnimal"
          ></upload-animals>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="tableSettings" max-width="500px">
      <v-card>
        <v-card-title> {{ $t("customization") }} </v-card-title>
        <v-card-text></v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            rounded
            @click="tableSettings = !tableSettings"
          >
            {{ $t("restoreDefault") }}
          </v-btn>
          <v-btn
            color="primary"
            rounded
            @click="tableSettings = !tableSettings"
          >
            {{ $t("apply") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="noAnimalPopup" max-width="500px">
      <v-card class="pb-5">
        <v-toolbar color="secondary" flat>
          <v-toolbar-title class="white--text">{{
            $t("error")
          }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-5 black--text font-weight-bold">
          {{ $t("errorNote") }}
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            color="primary"
            outlined
            @click="noAnimalPopup = !noAnimalPopup"
            large
            class="px-5"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="
              () => {
                noAnimalPopup = !noAnimalPopup;
                assignAnimalModal = true;
              }
            "
            large
            class="px-5"
          >
            {{ $t("Add Animal") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="maximumAnimalRegistered" max-width="500px">
      <v-card class="pb-5">
        <v-toolbar color="secondary" flat>
          <v-toolbar-title class="white--text">{{
            $t("error")
          }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-5 black--text font-weight-bold">
          {{ $t("limitNote") }}
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            color="primary"
            outlined
            @click="maximumAnimalRegistered = !maximumAnimalRegistered"
            large
            class="px-5"
          >
            {{ $t("ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <register-animal-dialog
      v-if="showRegisterAnimalDialog"
      :dialogI="showRegisterAnimalDialog"
      @closeDialog="showRegisterAnimalDialog = false"
    ></register-animal-dialog>
    <create-group-dialog
      @closeDialog="showCreateGroupDialog = false"
      @group:created="onGroupCreated"
      :animalCategories="animalCategories"
      :dialogI="showCreateGroupDialog"
      :newGroupName="newGroupName"
      :speciesTypes="speciesTypes"
      v-if="showCreateGroupDialog"
    />
    <!-- end -->
    <create-group-from-existing-dialog
      v-if="showCreateGroupFromExistingDialog"
      :dialogI="showCreateGroupFromExistingDialog"
      :groups="groups"
      @closeDialog="showCreateGroupFromExistingDialog = false"
      @group:selected="onExistingGroupSelected"
      @new-group:create="onNewGroupCreate"
    >
    </create-group-from-existing-dialog>
    <AssignZone
      :assignType="zoneAssignType"
      v-if="assignZoneModal"
      :dialogU="assignZoneModal"
      :group="selectedGroup"
      :farmId="farmId"
      @modal-closed="assignZoneModalClosed"
    />
    <AssignAnimalsToGroup
      v-if="assignAnimalModal"
      :dialogU="assignAnimalModal"
      :group="selectedGroup"
      @modal-closed="assignAnimalModalClosed"
    />
    <DeletePopup
      :dialogI="showDeleteDialog"
      v-if="showDeleteDialog"
      @delete="onDeleteGroup"
      @closeDialog="closeDeleteDialog"
    />
    <add-group-name
      v-if="addGroupName"
      :dialogI="addGroupName"
      @closeDialog="closeGroupCreateDialog"
      @updateTable="refresTable"
    >
    </add-group-name>
    <ungrouped-animals-dialog
      v-if="unGroupedAnimals"
      :dialogI="unGroupedAnimals"
      @createGroupName="createGroupName"
      @closeDialog="closeUngroupedAnimals"
    />

    <PdfConfirmationDialog
      v-if="showPdfConfirmationDialog"
      :dialogI="showPdfConfirmationDialog"
      :currentRecord="count"
      :totalRecords="totalCount"
      @exportToPdf="exportToPDF"
      @closePdfConfirmation="showPdfConfirmationDialog = false"
    >
    </PdfConfirmationDialog>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import AnimalService from "@/_services/AnimalService";
import UploadAnimals from "@/views/animals/UploadAnimals";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
import RegisterAnimalDialog from "./RegisterAnimalDialog.vue";
import CreateGroupFromExistingDialog from "./CreateGroupFromExistingDialog.vue";
import CreateGroupDialog from "./CreateGroupDialog.vue";
import PdfConfirmationDialog from "./dialog/PdfConfirmationDialog.vue";
import DeletePopup from "./DeletePopup.vue";
import { deleteGroup } from "@/graphql/Animals.gql";
// end
import gql from "graphql-tag";
import AssignZone from "./AssignZone.vue";
import AssignAnimalsToGroup from "./AssignAnimalToGroup.vue";
import {
  archiveAnimal,
  archiveAnimals,
  unArchiveAnimals,
  updateAnimalStatus,
  getAnimalList,
  downloadAnimalList,
} from "@/graphql/Animals.gql";
import UnGroupedAnimals from "@/views/feed_management/ration_library/DialogBox/UnGroupedAnimals";
import AddGroupName from "@/views/feed_management/ration_library/DialogBox/AddGroupName";

export default {
  apollo: {
    getAnimalList: {
      query: getAnimalList,
      update: data => data.getAnimalList.rows,
      fetchPolicy: "network-only",
      variables() {
        return {
          searchAnimalListInput: {
            byGroup: this.byGroup ? this.byGroup : null,
            type: this.type ? this.type : "",
            farmLocationId: Number(this.searchFarmId),
            categoryId: this.categoryId,
            search: this.isTypeGroup ? null : this.search,
            page: this.tableOptions.page,
            limit: this.tableOptions.itemsPerPage,
            // sort: this.sortBy,
          },
        };
      },
      result({ data }) {
        this.loading = false;
        console.log(this.selected);
        this.animals = data.getAnimalList.rows;

        if (!this.isTypeGroup) {
          this.totalCount = data.getAnimalList.totalCount;
        }
        this.count = data.getAnimalList.count;
      },
    },
    groups: {
      query: gql`
        query groups {
          groups {
            totalGroups
            groupData {
              id
              animalCounts
              bodyWeight
              name
              status
              geofenceZoneId {
                id
                geofenceName
              }
            }
            groupToAnimals
          }
        }
      `,
      skip: () => false,
      fetchPolicy: "network-only",
      variables() {
        return {
          page: this.tableOptions.page,
          limit: 10,
        };
      },
      update: data => data.groups.groupData,
      result({ data }) {
        this.groupToAnimals = data.groups.groupToAnimals;
        this.totalGroups = data.groups.totalGroups;
        this.groupData = data.groups.groupData;
        for (let el in data.groups.groupToAnimals) {
          this.animalIds.push(...data.groups.groupToAnimals[el]);
        }
      },
    },
    animalsCount: {
      query: gql`
        query animalsCount($farmLocationId: Int) {
          generalInformationsCount(farmLocationId: $farmLocationId) {
            calf
            dam
            heifer
            sire
            steer
            male
            female
            archived
            group
            all
            bulls
            lactatingCows
            dryCows
          }
        }
      `,
      variables() {
        return {
          farmLocationId: Number(this.searchFarmId),
        };
      },
      fetchPolicy: "network-only",
      update: data => data.generalInformationsCount,
    },
    animalCategories: {
      query: gql`
        query animalCategories {
          animalCategories {
            id
            name
          }
        }
      `,
      update: data => data.animalCategories,
    },
    animalPerformances: {
      query: gql`
        query animalPerformances($animalIds: [Int!]!) {
          animalPerformances(animalIds: $animalIds) {
            id
            live_weight
            animalId {
              id
            }
          }
        }
      `,
      skip: () => true,
      variables() {
        return {
          animalIds: this.animalIds,
        };
      },
      /* eslint-disable */
    },
    membership: {
      query: gql`
        query getCurrentMembershipOfCurrentUserFromHeader {
          getCurrentMembershipOfCurrentUserFromHeader {
            id
            membership_id
            payment_id
            start_date
            end_date
            active
            membershipData {
              membership_name
              satellite_report
              pasture_report
              membershipFeesData {
                is_free_trial
              }
            }
          }
        }
      `,
      update: data => data.getCurrentMembershipOfCurrentUserFromHeader,
      result({ data }) {
        if (
          data.getCurrentMembershipOfCurrentUserFromHeader &&
          data.getCurrentMembershipOfCurrentUserFromHeader.membershipData
        ) {
          this.isFreeMember =
            data.getCurrentMembershipOfCurrentUserFromHeader?.membershipData?.membershipFeesData?.is_free_trial;
          this.hasMembership = true;
        } else {
          this.hasMembership = false;
        }
      },
    },
    getFarmLocations: {
      query() {
        if (this.farmId && this.farmId > 0) {
          return gql`
            query farmLocations($farmId: Float) {
              farmLocations(farmId: $farmId) {
                address
                id
              }
            }
          `;
        }
      },
      variables() {
        return {
          farmId: null,
        };
      },
      update: data => data.farmLocations,
      fetchPolicy: "no-cache",

      result({ data }) {
        this.farmLocationList = data.farmLocations?.map(item => {
          return {
            id: item.id,
            address: item.address,
          };
        });

        this.filteredFarmLocationList = this.farmLocationList;
      },
      error(errors) {
        console.log("errors", errors);
      },
    },
  },
  components: {
    UploadAnimals,
    "register-animal-dialog": RegisterAnimalDialog,
    AssignZone,
    "create-group-from-existing-dialog": CreateGroupFromExistingDialog,
    "create-group-dialog": CreateGroupDialog,
    AssignAnimalsToGroup,
    DeletePopup,
    "ungrouped-animals-dialog": UnGroupedAnimals,
    "add-group-name": AddGroupName,
    PdfConfirmationDialog,
  },

  async mounted() {
    document.title = "Animals";
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
    this.tabletSelectHeaders = this.allSelectedHeaders.filter(
      h => h == "ID" || h == "Tag"
    );

    this.$apollo.queries.getAnimalList.skip = false;
    this.$apollo.queries.getAnimalList.refetch();
    this.$apollo.queries.membership.refetch();
    this.$apollo.queries.getFarmLocations.refetch();
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
    isTypeGroup() {
      return this.$route.query.type == "groups";
    },
    getAnimals() {
      if (this.isTypeGroup) return false;
      return this.animals.map(animal => {
        return {
          animalNumber: animal.livestockName,
          animalPicture: animal.animalPicture,
          breedId: animal.breedName,
          userBreed: animal.userBreedName,
          dob: animal.dateOfBirth,
          gender: animal.gender,
          id: animal.id,
          regDate: animal.dateOfRegistration,
          // status:
          //   animal.removalInformation &&
          //   animal.removalInformation.reasonForRemoval
          //     ? animal.removalInformation.reasonForRemoval
          //     : animal.status,
          status: animal.status,
          tagNumber: animal.tagNumber,
        };
      });
    },
    getGroups() {
      this.totalCount = this.getGroupData().length;
      return this.getGroupData();
    },
  },

  data() {
    return {
      unGroupedAnimals: false,
      addGroupName: false,
      showPdfConfirmationDialog: false,
      sortBy: [{ key: "id", order: "desc" }],
      showDeleteDialog: false,
      assignAnimalModal: false,
      zoneAssignType: "goal",
      groupData: [],
      groupToRange: {},
      animalPerformances: null,
      groupToAnimals: null,
      animalIds: [],
      assignZoneModal: false,
      noAnimalPopup: false,
      maximumAnimalRegistered: false,
      count: 0,
      showCreateGroupDialog: false,
      showCreateGroupFromExistingDialog: false,
      newGroupName: "",

      sortDesc: false,
      groups: [],
      categoryId: null,
      byGroup: false,
      type: "all",
      animalCategories: [],
      animalsCount: {
        all: 0,
        calf: 0,
        dam: 0,
        heifer: 0,
        sire: 0,
        steer: 0,
        group: 0,
        male: 0,
        female: 0,
        archived: 0,
        bulls: 0,
        dryCows: 0,
        lactatingCows: 0,
      },
      showRegisterAnimalDialog: false,
      from: 0,
      to: 0,
      totalCount: 0,
      totalPages: 1,
      pageCount: 0,
      tab: "",
      search: "",
      showUploadAnimal: false,
      itemsPerPage: 10,
      itemsPerPageSlider: 3,
      itemsPerPageOptions: [10, 25, 50, 100],
      tabletSelectHeaders: [],
      animalRemovalMenu: [
        { type: this.$t("animal.slaughter"), color: "error" },
        { type: this.$t("animal.movedToAnotherFarm"), color: "primary" },
        { type: this.$t("animal.sale"), color: "warning" },
        { type: this.$t("animal.death"), color: "gray" },
      ],
      allSelectedHeaders: [
        this.$t("animal.owner"),
        this.$t("animal.dam"),
        this.$t("animal.birthWeight"),
        this.$t("animal.surrogateDam"),
        this.$t("animal.birthEase"),
        this.$t("Status"),
        this.$t("animal.gender"),
        this.$t("animal.govtReg"),
        this.$t("id"),
        this.$t("animal.tag") + " #",
        this.$t("animal.dateOfBirth"),
        this.$t("animal.regDate"),
        this.$t("animal.breed"),
        this.$t("animal.birthFarm"),
        this.$t("animal.sire"),
      ],
      selectedHeaders: [],
      noRecordHeader: [
        this.$t("animal.owner"),
        this.$t("animal.dam"),
        this.$t("animal.birthWeight"),
        this.$t("animal.surrogateDam"),
        this.$t("animal.birthEase"),
      ],
      oldSelected: [],
      tableHeaders: [],
      menu: false,
      showAnimalType: "dam",
      tableSettings: false,
      animals: [],
      loading: false,
      tableOptions: { itemsPerPage: 10, page: 1 },
      tabletTableOptions: { itemsPerPage: 5, page: 1, sortBy: [] },
      totalAnimals: 0,
      steerCount: 0,
      sireCount: 0,
      damCount: 0,
      heiferCount: 0,
      calfCount: 0,
      selected: [],
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("animals"),
          disabled: true,
        },
      ],
      groupsTableHeaders: [
        {
          text: this.$t("Group Name"),
          align: "start",
          sortable: true,
          value: "name",
          width: "90px",
        },
        {
          text: this.$t("Body Weight"),
          align: "start",
          sortable: true,
          value: "bodyWeight",
          width: "90px",
        },
        {
          text: this.$t("# No of Animals"),
          align: "start",
          sortable: true,
          value: "animalCounts",
          width: "90px",
        },
        {
          text: this.$t("Status"),
          value: "groupStatus",
          sortable: true,
          width: "120px",
        },
        {
          text: this.$t("Assigned Zone"),
          value: "assignZone",
          sortable: false,
          width: "120px",
        },
        {
          text: this.$t(""),
          value: "actions",
          sortable: false,
          width: "120px",
        },
      ],
      animalSortkey: [
        { key: "id", order: "desc" },
        { key: "tag", order: "asc" },
        { key: "dob", order: "asc" },
        { key: "gender", order: "asc" },
        { key: "breed", order: "asc" },
        { key: "regDate", order: "asc" },
        { key: "status", order: "asc" },
      ],
      headers: [
        {
          text: this.$t("id"),
          align: "start",
          value: "id",
          width: "90px",
          key: "id",
        },
        {
          text: this.$t("animal.tag") + " #",
          value: "tagNumber",
          width: "120px",
          key: "tagNumber",
        },
        {
          text: this.$t("animal.dateOfBirth"),
          value: "dob",
          width: "140px",
          key: "dateOfBirth",
        },
        {
          text: this.$t("animal.gender"),
          value: "gender",
          width: "120px",
          key: "gender",
        },
        {
          text: this.$t("animal.breed"),
          value: "breedId",
          width: "120px",
          key: "breedId",
        },
        {
          text: this.$t("animal.regDate"),
          value: "regDate",
          width: "140px",
          key: "regDate",
        },
        {
          text: this.$t("Status"),
          value: "status",
          sortable: true,
          key: "status",
        },
        {
          text: "",
          value: "actions",
          width: "120px",
          key: "actions",
        },
      ],
      selectedGroup: null,
      isFreeMember: false,
      hasMembership: false,
      groupToDelete: null,
      farmLocationList: [],
      filteredFarmLocationList: [],
      searchFarmId: null,
      searchFarmAddress: "",
    };
  },
  watch: {
    tableOptions: {
      handler(nV) {
        console.log(nV.sortBy?.length);
        if (!Array.isArray(nV.sortBy) && nV.sortBy?.length) {
          const order = nV.sortDesc[0] ? "desc" : "asc";
          this.sortBy = [{ key: nV.sortBy[0], order: order }];
        }

        if (this.isTypeGroup) {
          this.$apollo.queries.groups.refetch();
        } else {
          this.$apollo.queries.getAnimalList.refetch();
        }
      },
      deep: true,
    },
    // groupToRange(nV) {
    //   let tmpData = JSON.parse(JSON.stringify(this.groupData));
    //   this.groupData = tmpData.map((group) => {
    //     let resObj = {
    //       id: group.id,
    //       name: group.name,
    //       bodyWeight: group.bodyWeight,
    //       animalCounts: group.animalCounts,
    //       groupStatus: group.status,
    //       status: group.groupStatus,
    //       geofenceZoneId: group.geofenceZoneId,
    //       gefenceZoneName:
    //         group.geofenceZoneId && group.geofenceZoneId.geofenceName,
    //     };
    //     if (this.groupToRange[group.id]) {
    //       resObj.bodyWeight = this.groupToRange[group.id];
    //     }
    //     return resObj;
    //   });
    // },
    groupToAnimals: {
      async handler(nV) {
        this.$apollo.queries.animalPerformances.skip = false;
        let res = await this.$apollo.queries.animalPerformances.refetch();
        let animalPerformances = res.data.animalPerformances;

        let animalsToGroups = {};
        for (let group in nV) {
          nV[group].forEach(animal => {
            animalsToGroups[animal] = group;
          });
        }
        console.log(animalsToGroups, "groupToAnimals");
        console.log(animalPerformances, "animalPerformances");
        let animalsToPerf = {};
        let groupToPerf = {};
        let groupToRange = {};

        animalPerformances.forEach(p => {
          animalsToPerf[p.animalId.id] = p.live_weight;
        });

        console.log(animalsToPerf);

        for (let aid in animalsToPerf) {
          groupToPerf[animalsToGroups[aid]] = [
            ...(groupToPerf[animalsToGroups[aid]] || []),
            animalsToPerf[aid],
          ];
        }

        for (let gId in groupToPerf) {
          let tmpArr = [];
          tmpArr = groupToPerf[gId].sort((a, b) => {
            if (a > b) return 1;
            if (a < b) return -1;
            return 0;
          });
          if (tmpArr.length > 0) {
            groupToRange[gId] = `${tmpArr[0]} - ${tmpArr[tmpArr.length - 1]}`;
          }
        }

        this.groupToRange = JSON.parse(JSON.stringify(groupToRange));
        console.log(groupToRange, "groupToRange");
      },
    },
    // selected(values){
    //   console.log(values,"valuesvaluesvaluesvalues")
    //   if(values.length > 0){
    //     console.log(values,"valuesvaluesvaluesvalues")
    //   }
    // }
  },

  methods: {
    async searchByFarmId() {
      await this.$apollo.queries.getAnimalList.refetch();
      await this.$apollo.queries.animalsCount.refetch();
      this.stopLoading();
    },
    searchFarmLocation() {
      this.filteredFarmLocationList = this.farmLocationList.filter(item => {
        return (
          item.address
            .toLowerCase()
            .indexOf(this.searchFarmAddress.toLowerCase()) > -1
        );
      });
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
    },
    async onDeleteGroup() {
      await this.$apollo
        .query({
          query: deleteGroup,
          variables: {
            groupId: +this.groupToDelete.id,
          },
        })
        .then(data => {
          if (data.deleteGroup) {
            this.$notify({
              title: `Success!`,
              text: `Group deleted successfully!`,
              type: "success",
              position: "top right",
            });
          }
          this.showDeleteDialog = false;
          this.$apollo.queries.groups.refetch();
        })
        .catch(e => {
          this.showDeleteDialog = false;
          this.$notify({
            title: `Error!`,
            text: `Unable to delete record!`,
            type: "error",
            position: "top right",
          });
          Promise.reject(e);
        });
    },
    findMatches(text, substring) {
      const matches = [];
      let currentIndex = text.indexOf(substring);
      while (currentIndex !== -1) {
        matches.push(currentIndex);
        currentIndex = text.indexOf(substring, currentIndex + 1);
      }
      return matches.length > 0 ? true : false;
    },
    getGroupData() {
      let result = this.groupData.map(group => {
        let resObj = {
          id: group.id,
          name: group.name,
          bodyWeight: group.bodyWeight,
          animalCounts: group.animalCounts,
          groupStatus: group.status,
          geofenceZoneId: group.geofenceZoneId,
          gefenceZoneName:
            group.geofenceZoneId && group.geofenceZoneId.geofenceName,
        };
        if (this.groupToRange[group.id]) {
          resObj.bodyWeight = this.groupToRange[group.id];
        } else {
          resObj.bodyWeight = "0 - 0";
        }

        if (this.isTypeGroup && this.search && this.search.length > 0) {
          if (this.findMatches(group.name, this.search)) {
            return resObj;
          }
        } else {
          return resObj;
        }
      });

      if (this.isTypeGroup && this.search && this.search.length > 0) {
        result = result.filter(data => {
          return data != undefined;
        });
      }
      return result;
    },
    assignAnimaltoGroup(group) {
      this.selectedGroup = group;
      this.assignAnimalModal = true;
    },
    assignAnimalModalClosed(success) {
      this.selectedGroup = null;
      this.assignAnimalModal = false;
      if (success == true) {
        this.$apollo.queries.groups.refetch();
      }
    },
    bulkAnimalAction(action) {
      if (action == "archiveAnimal") {
        if (this.selected.length <= 0) return;
        this.startLoading();
        let animalIds = this.selected.map(function (element) {
          return parseInt(element.id);
        });
        this.$apollo
          .mutate({
            mutation: archiveAnimals,
            variables: {
              animalIds: animalIds,
            },
          })
          .then(async ({ data }) => {
            if (data.archiveAnimals.success) {
              await this.$apollo.queries.getAnimalList.refetch();
              await this.$apollo.queries.animalsCount.refetch();

              this.stopLoading();
            }
          })
          .catch(e => {
            console.log("arc", e);
            this.stopLoading();
          });
      } else if (action == "moveToGroup") {
        this.showCreateGroupFromExistingDialog = true;
      } else if (action == "unarchived") {
        if (this.selected.length <= 0) return;
        this.startLoading();
        let animalIds = this.selected.map(function (element) {
          return parseInt(element.id);
        });
        this.$apollo
          .mutate({
            mutation: unArchiveAnimals,
            variables: {
              animalIds: animalIds,
            },
          })
          .then(async ({ data }) => {
            if (data.unArchiveAnimals.success) {
              await this.$apollo.queries.getAnimalList.refetch();
              await this.$apollo.queries.animalsCount.refetch();
              this.stopLoading();
            }
          })
          .catch(e => {
            console.log("arc", e);
            this.stopLoading();
          });
      }
    },
    unArchiveAnimal(item) {
      this.startLoading();
      let animalIds = [parseInt(item.id)];
      this.$apollo
        .mutate({
          mutation: unArchiveAnimals,
          variables: {
            animalIds: animalIds,
          },
        })
        .then(async ({ data }) => {
          if (data.unArchiveAnimals.success) {
            await this.$apollo.queries.getAnimalList.refetch();
            await this.$apollo.queries.animalsCount.refetch();
            this.stopLoading();
          }
        })
        .catch(e => {
          console.log("arc", e);
          this.stopLoading();
        });
    },
    archiveAnimal(item) {
      this.startLoading();
      this.$apollo
        .mutate({
          mutation: archiveAnimal,
          variables: {
            animalId: parseInt(item.id),
          },
        })
        .then(async ({ data }) => {
          if (data.archiveAnimal.success) {
            await this.$apollo.queries.getAnimalList.refetch();
            await this.$apollo.queries.animalsCount.refetch();
            this.stopLoading();
          }
        })
        .catch(e => {
          console.log("arc", e);
          this.stopLoading();
        });
    },
    assignZonetoAnimal(item) {
      this.zoneAssignType = "animal";
      this.selectedGroup = item;
      this.assignZoneModal = true;
    },
    assignZonetoGoal(item) {
      if (item.animalCounts < 1) {
        this.noAnimalPopup = true;
      } else {
        this.selectedGroup = item;
        this.assignZoneModal = true;
      }
    },
    assignZoneModalClosed(success) {
      this.selectedGroup = null;
      this.assignZoneModal = false;
      if (success == true) {
        this.$apollo.queries.groups.refetch();
        // this.getGroups()
      }
    },
    async fetchAnimals(type) {
      console.log("type =>", type);
      this.search = "";
      this.selected = [];
      this.type = null;
      this.byGroup = false;
      this.categoryId = null;
      this.tableOptions.page = 1;

      if (
        type === "dam" ||
        type === "sire" ||
        type === "male" ||
        type === "female" ||
        type === "archived"
      ) {
        this.type = type;
      } else if (type === "group") {
        this.byGroup = true;
      } else {
        this.categoryId = parseInt(type);
      }

      this.$apollo.queries.getAnimalList.skip = false;
      await this.$apollo.queries.getAnimalList.refetch();
    },

    async changeStatus(item, status) {
      this.$apollo
        .mutate({
          mutation: updateAnimalStatus,
          variables: {
            updateAnimalStatusInput: { id: parseInt(item.id), status: status },
          },
        })
        .then(res => {
          this.$apollo.queries.getAnimalList.refetch();
          this.$notify({
            title: "Animal Status updated successfully ",
            text: "Animal Status updated successfully.",
            type: "success",
          });
        })
        .catch(err => {
          console.log("err", err.response);
        });
    },

    getCategoryId(category) {
      const animalCategory = this.animalCategories.find(
        _category => _category.name.toLowerCase() === category.toLowerCase()
      );

      return animalCategory ? parseInt(animalCategory.id) : null;
    },

    registerAnimal() {
      this.showRegisterAnimalDialog = true;
    },
    pdfDownloadConfirmation() {
      this.showPdfConfirmationDialog = true;
      // const element = document.querySelector(".v-data-table__wrapper");

      // const cloneElement = element.cloneNode(true);
      // const firstColumnHeaders = cloneElement.querySelectorAll(
      //   ".v-data-table-header th:first-child, .v-data-table-header th:last-child"
      // );
      // const firstColumnDataCells = cloneElement.querySelectorAll(
      //   "td:first-child, td:last-child"
      // );

      // firstColumnHeaders.forEach((header) => {
      //   header.style.display = "none";
      // });
      // firstColumnDataCells.forEach((cell) => {
      //   cell.style.display = "none";
      // });

      // html2pdf(cloneElement, {
      //   margin: 0.7,
      //   filename: "AnimalsList.pdf",
      //   image: { type: "jpeg", quality: 0.98 },
      //   html2canvas: { dpi: 200, letterRendering: true },
      //   jsPDF: {
      //     unit: "in",
      //     format: "letter",
      //     orientation: "landscape",
      //     compress: false,
      //   },
      // });
    },

    async exportToPDF(data) {
      this.startLoading();
      const response = await this.$apollo.query({
        query: downloadAnimalList,
        fetchPolicy: "no-cache",
        variables: {
          searchAnimalListInput: {
            byGroup: this.byGroup ? this.byGroup : null,
            type: data,
            farmLocationId: Number(this.searchFarmId),
            categoryId: this.categoryId,
            search: this.isTypeGroup ? null : this.search,
            page: this.tableOptions.page,
            limit: this.tableOptions.itemsPerPage,
            // sort: this.sortBy,
          },
        },
      });
      console.log(response);
      if (response?.data?.downloadAnimalList) {
        this.stopLoading();
        const pdfData = response?.data?.downloadAnimalList;

        // Convert the base64 PDF data back to binary
        const pdfBinary = this.base64ToUint8Array(pdfData);

        // Create a Blob from the binary data
        const pdfBlob = new Blob([new Uint8Array(pdfBinary)], {
          type: "application/pdf",
        });

        // Create a temporary URL for the Blob
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Create an <a> element to trigger the download
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "exported.pdf";
        link.click();

        // Clean up the URL
        URL.revokeObjectURL(pdfUrl);
      } else {
        this.stopLoading();
      }

      this.showPdfConfirmationDialog = false;
    },
    // Convert base64 to Uint8Array
    base64ToUint8Array(base64) {
      const binaryString = window.atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      return bytes;
    },
    async printPDF() {
      const element = document.querySelector(".v-data-table__wrapper");

      let opt = {
        margin: 1,
        filename: "AnimalsList.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(element)
        .toCanvas()
        .outputPdf("blob", "AnimalsList.pdf");
      let file = new File([worker], "AnimalsList.pdf", {
        type: "application/pdf",
      });
      console.log(file);
      var pdfUrl = await URL.createObjectURL(file);
      console.log(pdfUrl);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    getAnimalsData() {
      if (!this.showAnimalType) return;
    },
    uploadAnimal() {
      this.showUploadAnimal = true;
    },
    closeUploadAnimal() {
      this.showUploadAnimal = false;
      // if (success === true) {
      //   this.tab = 3;
      //   this.importKey = this.importKey + 1;
      // }
    },
    getTabletAnimalsData() {
      if (!this.showAnimalType) return;
      this.loading = true;
      AnimalService.getAnimals(
        this.showAnimalType,
        this.tabletTableOptions,
        this.search
      )
        .then(res => {
          if (res.success) {
            this.animals = res.data.rows;
            this.totalAnimals = res.data.totalRows;
            if (this.totalAnimals < 1) {
              this.oldSelected = this.selectedHeaders;
              this.selectedHeaders = this.noRecordHeader;
            } else {
              if (this.oldSelected.length > 1)
                this.selectedHeaders = this.oldSelected;
              else {
                this.selectedHeaders = this.allSelectedHeaders;
                this.oldSelected = [];
              }
            }
            this.resetTableStructure();

            this.steerCount = res.data.steerCount;
            this.sireCount = res.data.sireCount;
            this.heiferCount = res.data.heiferCount;
            this.calfCount = res.data.calfCount;
            this.damCount = res.data.damCount;
            this.pageCount = Math.ceil(
              this.totalAnimals / this.tabletTableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalAnimals / this.tabletTableOptions.itemsPerPage
            );
            this.from =
              (this.tabletTableOptions.page - 1) *
                this.tabletTableOptions.itemsPerPage +
              1;
            this.to =
              this.tabletTableOptions.page *
                this.tabletTableOptions.itemsPerPage -
              (this.tabletTableOptions.itemsPerPage - res.data.numRows);
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    rowClicked(item) {
      console.log(item);
      if (this.isTypeGroup) {
        if (item?.name === "Ungrouped Animals") {
          this.unGroupedAnimals = true;
        } else {
          this.$router.push({
            name: "AnimalGroup",
            params: { id: item.id },
          });
        }
        return;
      }

      let index = this.animals.indexOf(item);
      // let farmList = JSON.parse(JSON.stringify(this.items))
      let remainingAnimalList = this.animals.slice(index);
      let remainingAnimalNumber = remainingAnimalList.map(item => {
        return item.animalNumber;
      });
      localStorage.setItem("animals", remainingAnimalNumber);

      this.$router.push({
        name: "AnimalDetails",
        params: { animal_number: item.id, gender: item.gender },
      });
    },
    moveToGroup(item) {
      console.log(item);
      this.selectedAnimal = item;
      this.showCreateGroupFromExistingDialog = true;
    },
    async onExistingGroupSelected(existingGroupId) {
      if (existingGroupId) {
        let animalToUpdate = {
          //id: this.selectedAnimal.id,
          groupId: parseInt(existingGroupId),
        };
        await this.updateAnimal(animalToUpdate);
        this.showCreateGroupFromExistingDialog = false;
      }
    },
    onNewGroupCreate(newGroupName) {
      console.log("new group", newGroupName);
      if (newGroupName) {
        this.newGroupName = newGroupName;
        this.showCreateGroupFromExistingDialog = false;
        this.showCreateGroupDialog = true;
      }
    },
    async onGroupCreated(newGroup) {
      await this.$apollo.queries.groups.refetch();
      let animalToUpdate = {
        id: this.selectedAnimal.id,
        groupId: parseInt(newGroup.id),
      };
      await this.updateAnimal(animalToUpdate);
    },
    clickEditAnimal(id) {
      this.$router.push({
        name: "EditAnimal",
        params: { animal_number: id },
      });
    },
    gotoPerformance(id) {
      this.$router.push(`/animals/${id}/performance`);
    },
    resetDefaut() {
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
      this.menu = false;
    },
    resetTableStructure() {
      this.startLoading();
      this.tableHeaders = this.headers.filter(header =>
        this.selectedHeaders.includes(header.text)
      );
      this.tableOptions.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      this.stopLoading();
    },
    searchAnimals() {
      if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        // this.getTabletAnimalsData();
      } else {
        this.tableOptions.page = 1;
        // this.getAnimalsData();
      }
      if (this.isTypeGroup) {
        // this.getGroupData();
        this.getGroups;
      } else {
        this.$apollo.queries.getAnimalList.refetch();
      }
    },
    createGroupName() {
      this.unGroupedAnimals = false;
      this.addGroupName = true;
    },
    resetSearchOnEmpty() {
      if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        // this.getTabletAnimalsData();
      } else {
        this.tableOptions.page = 1;
        // this.getAnimalsData();
      }

      if (this.isTypeGroup) {
        // this.getGroupData();
        this.getGroups;
      } else {
        this.$apollo.queries.getAnimalList.refetch();
      }
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;

      this.$apollo.queries.getAnimalList.skip = false;
      this.$apollo.queries.getAnimalList.refetch();
    },
    deleteGroup(item) {
      console.log(item);
      this.showDeleteDialog = true;
      this.groupToDelete = item;
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;

      this.$apollo.queries.getAnimalList.refetch();
    },
    async updateAnimal(animalToUpdate) {
      this.startLoading();

      let formData = {
        animalIds:
          this.selected && this.selected.length
            ? this.selected.map(selectedAnimal => parseInt(selectedAnimal.id))
            : [parseInt(this.selectedAnimal.id)],
        groupId: animalToUpdate.groupId,
        oldGroupId: null,
      };

      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($data: AssignAnimalsToGroupInput!) {
              assignAnimalsToGroup(assignAnimalsToGroup: $data)
            }
          `,
          // Parameters
          variables: {
            data: formData,
          },
        })
        .then(async res => {
          if (res.data.assignAnimalsToGroup) {
            await this.$apollo.queries.getAnimalList.refetch();
            await this.$apollo.queries.animalsCount.refetch();
            this.stopLoading();
            this.$notify({
              title: "Animal Group Updated Successfully",
              text: "", //res.message,
              type: "success",
            });
          } else {
            this.stopLoading();
            this.$notify({
              title: "Animal Group Not Updated",
              text: res.message,
              type: "error",
            });
          }
        })
        .catch(({ data }) => {
          if (data.status == 422) {
            data.message.errors.forEach(em => {
              this.errors[em.param] = em.msg;
            });
          }
          this.stopLoading();
        });
    },
    checkIfFreeMemberAndMoreThanHunderdAnimals() {
      if (this.isFreeMember && this.totalCount > 100) {
        this.maximumAnimalRegistered = true;
      } else {
        this.$router.push({ name: "AddAnimal", params: { type: "single" } });
      }
    },
    closeGroupCreateDialog() {
      debugger;
      this.isTypeGroup = true;
      this.unGroupedAnimals = false;
      this.addGroupName = false;
      this.$router.push({
        name: "Animals",
        query: { type: "groups" },
      });
    },
    refresTable() {
      debugger;
      this.isTypeGroup = true;
      this.unGroupedAnimals = false;
      this.isTypeGroup = true;
      this.$router.push({
        name: "Animals",
        query: { type: "groups" },
      });
    },
    closeUngroupedAnimals() {
      this.unGroupedAnimals = false;
      this.isTypeGroup = true;
      this.getGroups();

      this.$router.push({
        name: "Animals",
        query: { type: "groups" },
      });
    },
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}

::v-deep .v-data-table-header {
  background: $secondary2-color;
}

::v-deep .v-data-table-header span {
  color: black;
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

// ::v-deep .v-list {
//   background: #000 !important;
// }

::v-deep #farm-select .v-list {
  background-color: #fff !important;
  color: #000 !important;
}
::v-deep #farm-select .v-list-item {
  color: #000 !important;
}

::v-deep #farm-select input::placeholder {
  color: #bbb;
}

// ::v-deep .v-list-item {
//   color: #fff !important;
// }
::v-deep .v-list-item__content {
  cursor: pointer !important;
}
</style>
